<div
    class="accessibility-facet-wrapper selenium-accessibility-facet"
    [ngClass]="{
        hidden: adaptationTypesOptions.length === 0 && controlFlexibilityOptions.length === 0
    }"
>
    <div class="facet-title" (click)="onToggle()">
        <span class="toggle" [ngClass]="{ visible: isCollapsed }">
            <i class="fas fa-plus"></i>
        </span>
        <span class="toggle" [ngClass]="{ visible: !isCollapsed }">
            <i class="fas fa-minus"></i>
        </span>
        Accessibility
        <span *ngIf="selectedFiltersCount">({{ selectedFiltersCount }})</span>
    </div>
    <div
        class="facet-content"
        [ngClass]="{
            hidden:
                isCollapsed ||
                (adaptationTypesOptions.length === 0 && controlFlexibilityOptions.length === 0)
        }"
    >
        <div class="facet-subcontent" [ngClass]="{ visible: adaptationTypesOptions.length > 0 }">
            <div class="facet-subtitle selenium-facet-adaptation-header">Adaptation Types</div>
            <div class="options-wrapper">
                <div class="option" *ngFor="let option of adaptationTypesOptions">
                    <input
                        type="checkbox"
                        [id]="option.label"
                        [attr.data-gtmlabel]="option.label"
                        [ngModel]="option.checked"
                        (change)="onCheckboxChange($event, option)"
                    />
                    <label [for]="option.label">{{ option.label }}</label>
                </div>
            </div>
        </div>
        <div class="facet-subcontent" [ngClass]="{ visible: controlFlexibilityOptions.length > 0 }">
            <div class="facet-subtitle selenium-facet-control-header">Control Flexibility</div>
            <div class="options-wrapper">
                <div class="option" *ngFor="let option of controlFlexibilityOptions">
                    <input
                        type="checkbox"
                        [id]="option.label"
                        [attr.data-gtmlabel]="option.label"
                        [ngModel]="option.checked"
                        (change)="onCheckboxChange($event, option)"
                    />
                    <label [for]="option.label">{{ option.label }}</label>
                </div>
            </div>
        </div>
    </div>
</div>
